<template>
  <div class="d-flex">
    <div
      v-if="statusFilter"
      class="relative pointer"
      @click="removeFilter('setStatusFilter')"
    >
      <div class="remove-icon">
        <span class="remove-icon-color">
          <i class="fas fa-times-circle" />
        </span>
      </div>
      <div class="filter-selected-container">
        <div class="mr-2">
          <span class="filter-button">{{ $t('status') }}: </span>
          <span>{{ getStatusDisplay(statusFilter) | capitalize }}</span>
        </div>
      </div>
    </div>
    <div
      v-if="useTypeFilter"
      class="relative pointer ml-4"
      @click="removeFilter('setUseTypeFilter')"
    >
      <div class="remove-icon">
        <span class="remove-icon-color">
          <i class="fas fa-times-circle" />
        </span>
      </div>
      <div class="filter-selected-container">
        <div>
          <span class="filter-button">{{ $t('useType') }}: </span>
          <span>{{ (useTypeFilter) | get('name') }}</span>
        </div>
      </div>
    </div>

    <div
      v-if="memberFilter"
      class="relative pointer ml-4"
      @click="removeFilter('setMemberFilter')"
    >
      <div class="remove-icon">
        <span class="remove-icon-color">
          <i class="fas fa-times-circle" />
        </span>
      </div>
      <div class="filter-selected-container">
        <div>
          <span class="filter-button">{{ $t('member') }}: </span>
          <span>{{ (memberFilter)|get('username') }}</span>
        </div>
      </div>
    </div>

    <div
      v-if="showIneligible"
      class="relative pointer ml-4"
      @click="removeFilter('setShowIneligible')"
    >
      <div class="remove-icon">
        <span class="remove-icon-color">
          <i class="fas fa-times-circle" />
        </span>
      </div>
      <div class="filter-selected-container">
        <div>
          <span class="filter-button">{{ $t('showIneligible') | capitalize }}:</span>
          <span>True</span>
        </div>
      </div>
    </div>
  </div>
</template>


<style lang="scss" scoped>
.filter-button {
  height: 40px;
  text-align: center;
  cursor: pointer;
  width: 100px;
  border-radius: 50px;
  color: #0091ff;
}

.filter-selected-container {
  box-shadow: 0 0 5px 0;
  display: flex;
  border-radius: 8px;
  padding: 3px 10px;
}

.remove-icon {
  position: absolute;
  right: -5px;
  bottom: 15px;
}

.remove-icon-color {
  color: red;
  background-color: white;
}
</style>
<script>
import { mapGetters, mapMutations, mapState } from "vuex"

export default {
  name: "SelectedFilters",
  computed: {
    ...mapState("ui", ["statusFilter", "useTypeFilter", "memberFilter", "showIneligible"]),
    ...mapGetters("soundsys", ["statusTypes"])
  },

  methods: {
    ...mapMutations("ui", [
      "setStatusFilter",
      "setUseTypeFilter",
      "setMemberFilter",
      "setShowIneligible",
    ]),
    updateFilter (filterField, val) {
      let queryFilters = { ...this.$route.query }
      if (!val) {
        delete queryFilters[filterField]
      } else {
        queryFilters[filterField] = val
      }
      this.table.options.previousPage = null
      queryFilters.page = 1
      this.$router.replace({
        name: this.$route.name,
        query: queryFilters
      })
    },
    removeFilter (filter) {
      const filterFields = {
        setMemberFilter: "member",
        setShowIneligible: "in_eligible",
        setStatusFilter: "status",
        setUseTypeFilter: "use_type",

      }
      this[filter](null)

      this.updateFilter(filterFields[filter], null)
    },
    getStatusDisplay (status) {
      return {
        // from UsageFilesTable.vue
        [this.statusTypes.PENDING]: this.$t("pending"),
        [this.statusTypes.PROCESSING]: this.$t("processing"),
        [this.statusTypes.INGESTED]: this.$t("ingested"),
        [this.statusTypes.LANDED]: this.$t("landed"),
        [this.statusTypes.MATCHED]: this.$t("matched"),
        [this.statusTypes.ERROR]: this.$t("error"),
        // from LandingSRsList.vue
        [this.statusTypes.CREATED]: this.$t("created"),
        [this.statusTypes.LINKED]: this.$t("linked"),
        [this.statusTypes.MANUALLY_CREATED]: this.$t("manually_created"),
        [this.statusTypes.MANUALLY_LINKED]: this.$t("manually_linked"),
        [this.statusTypes.PENDING_FOR_VALIDATION]: this.$t("pending_for_validation"),
        // from UsagesPage.vue
        [this.statusTypes.UNMATCHED]: this.$t("unmatched"),
        [this.statusTypes.UNMATCHED_NO_DUPLICATES]: this.$t("unmatched_no_duplicates"),
        [this.statusTypes.AUTOMATCHED]: this.$t("automatched"),
        [this.statusTypes.MANUALLY_MATCHED]: this.$t("manually_matched"),
        [this.statusTypes.AUTO_MANUALLY_MATCHED]: this.$t("auto_manually_matched"),
        [this.statusTypes.UNMATCHED_READY_FOR_DISTRIBUTION]: this.$t("unmatched_ready_for_distribution"),
        // from SoundRecordingTable.vue
        [this.statusTypes.CLAIMED]: this.$t("claimed"),
        [this.statusTypes.UNCLAIMED]: this.$t("unclaimed"),
        [this.statusTypes.OVERCLAIMED]: this.$t("overclaimed"),
        [this.statusTypes.UNDERCLAIMED]: this.$t("underclaimed")
      }[status]
    }
  },
  props: {
    table: {
      type: Object
    }
  }
}
</script>
